import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {useMapValidator} from './useMapValidator'
import {usePlayerValidators} from './usePlayerValidators'
import {useCurrentStateValidator} from './useCurrentStateValidator'
import {MechanicValidatorCity} from '@colonist/game-mechanic-validators'

export const useMechanicValidatorCity = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const currentStateValidator = useCurrentStateValidator()
    const mechanicCityState = useGameStore((state) => state.gameState.mechanicCityState)

    return useMemo(() => {
        if(!mechanicCityState) return undefined
        return new MechanicValidatorCity(playerValidators, mapValidator, currentStateValidator, mechanicCityState)
    }, [playerValidators, mapValidator, currentStateValidator, mechanicCityState])
}

